var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "validator"
  }, [_c('div', {
    staticClass: "rank"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.validator.rank))])])]), _c('div', {
    staticClass: "id_col"
  }, [_c('p', [_vm._v(_vm._s(_vm.validator.nodeID))]), _c('p', [_vm._v(_vm._s(_vm.duration))])]), _c('div', {
    staticClass: "stake_col"
  }, [_c('p', {
    staticClass: "stakeAmount"
  }, [_vm._v(_vm._s(_vm.stakeAmountText) + " DCM")]), _c('p', [_vm._v(_vm._s(_vm.stakePercText) + "%")])]), _c('div', {
    staticClass: "comm_col"
  }, [_c('p', [_vm._v(_vm._s(_vm.cumulativePercText) + "%")]), _c('CumulativeBar', {
    attrs: {
      "total": _vm.totalStake,
      "amount": _vm.stakeAmount,
      "accumulated": _vm.cumulativeStake
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }